const stylesMed = {
    mainContainer: {
        backgroundColor: "#e6e6fa",
        height: "100%"
    },
    spinner: {
        backgroundColor: "#e6e6fa",
        color: "#00bfff"
    },
    mainBackgroundColor: {
        backgroundColor: "#e6e6fa",
        flex: 1,
    },
    checkDiv: {
        backgroundColor: "#ffffff",
        height: 130
    },
    clientNameRoute: {
        color: "#00bfff",
        fontSize: 25,
        marginTop: 10,
        marginBottom: 0
    },
    clientPotential: {
        fontSize: 17
    },
    clientName: {
        color: "#00bfff",
        fontSize: 25,
        marginBottom: 0
    },
    clientDetail: {
        marginBottom: 0
    },
    searchInputHalf: {
        width: "45%",
        marginLeft: "1%"
    },
    wideButtonFilter: {
        backgroundColor: '#00bfff',
        borderColor: '#00bfff',
        color: '#ffffff',
    },
    wideButton: {
        backgroundColor: '#00bfff',
        borderColor: '#00bfff',
        color: '#ffffff',
        width: 150
    },
    wideButtonUnclicked: {
        width: 150
    },
    wideButtonRequired: {
        backgroundColor: '#00bfff',
        borderColor: 'red',
        color: '#ffffff',
        width: 150
    },
    cancelWideButton: {
        width: 150
    },
    deleteButton: {
        backgroundColor: '#00bfff',
        borderColor: '#00bfff',
        color: '#ffffff',
    },
    editButton: {
        backgroundColor: '#00bfff',
        borderColor: '#00bfff',
        color: '#ffffff',
        marginLeft: 10 
    },
    deleteButtonAlert: {
        backgroundColor: '#00bfff',
        borderColor: '#00bfff',
        color: '#ffffff',
        marginRight: 10
    },
    cancelButtonAlert: {
        marginRight: 10
    },
    checkbox: {
        color: "#00bfff"
    },
    logisticInputs: {
        width: 250
    },
    clientNameDetail: {
        width: 150,
        marginTop: 20
    },
    clientDetailCard: {
        backgroundColor: "#ffffff",
        marginBottom: 0
    },
    prevTab: {
        width: "100%",
        maxWidth: "100%",
        height: 100,
        borderRadius: 10
    },
    LandingModules: {
        backgroundColor: "#e6e6fa",
        width: "37.5%"
    },
    cardBackgroundColor: {
        backgroundColor: "#ffffff"
    },
    reportsTitle: {
        marginLeft: "15%"
    },
    reportType: {
        fontWeight: "bold",
        width: 500,
        maxWidth: "100%",
    },
    reportInputWidth: {
        width: 500,
        maxWidth: "100%",
    },
    reportTypeInput: {
        width: 200
    },
    reportClientInput: {
        width: 300
    },
    reportClientInputRequired: {
        width: 300,
        borderColor: "red"
    },
    reportTableHeader: {
        backgroundColor: '#0296bf',
        marginTop: 50,
        marginLeft: 5,
        marginRight: 5
    },
    reportTableItem: {
        color: '#ffffff'
    },
    reportTableRow: {
        marginLeft: 5,
        marginRight: 5,
        borderWidth: "1px",
        borderStyle: "Solid"
    },
    reportDate: {
        marginBottom: 0
    },
    planTabs: {
        width: "100%",
        height: 100,
        borderRadius: 10
    },
    planItemDetailName: {
        fontSize: 20,
        fontWeight: "bold"
    },
    planItemDetail: {
        backgroundColor: "#d3d3e6"
    },
    planVisitCompleted: {
        color: "green",
        fontWeight: "bold"
    },
    planVisitPending: {
        color: "red",
        fontWeight: "bold"
    },
    planVisitCancelled: {
        color: "grey",
        fontWeight: "bold"
    },
    planVisitDate: {
        fontSize: 20,
        fontWeight: "bold"
    },
    planInput: {
        width: 300
    },
    productCard: {
        width: 150,
        height: 150
    },
    dailyDate: {
        marginLeft: 0,
        marginTop: 8
    },
    dailyTabs: {
        marginTop: 50
    },
    dailyCard: {
        width: "100%",
        height: 60,
        borderRadius: 10
    },
    dailyCompleted: {
        backgroundColor: "#b9faaf"
    },
    dailyPending: {
        backgroundColor: "#d3d3e6"
    },
    dailyCoached: {
        backgroundColor: "#ffff99"
    },
    dailyNumber: {
        fontSize: 20,
        fontWeight: "bold"
    },
    dailyMargin: {
        marginBottom: 0
    },
    activityTitle: {
        marginTop: 20,
    },
    activityTypeInput: {
        width: 200
    },
    activityTypeInputRequired: {
        width: 200,
        borderColor: "red"

    },
    activityCostInput: {
        width: 200
    },
    activityCostInputRequired: {
        width: 200,
        borderColor: "red"
    },
    activityNameRequired: {
        borderColor: "red"
    },
    activitypurposeInput: {
        height: 100
    },
    activityNotCompleted: {
        backgroundColor: '#00bfff',
        borderColor: '#00bfff',
        color: '#ffffff',
        width: 150
    },
    activityCompleted: {
        backgroundColor: '#0296bf',
        borderColor: '#0296bf',
        color: '#ffffff',
        width: 150
    },
    activitylocation: {
        width: "30%"
    },
    activityQty: {
        width: 200
    },
    activityShow: {
        backgroundColor: '#0296bf',
        borderColor: '#0296bf',
        color: '#ffffff',
        width: "100%"
    },
    activityHide: {
        backgroundColor: '#00bfff',
        borderColor: '#00bfff',
        color: '#ffffff',
        width: "100%"
    },
    routeDate: {
        marginTop: 10
    },
    rightDirection: {
        float: "right",
        textAlign: "right"
    },
    visitTitle: {
        marginTop: 20
    },
    visitTableHeader: {
        backgroundColor: '#0296bf'
    },
    visitCheckbox: {
        height: 30,
        width: 30,
        marginLeft: 10
    },
    visitProductCode: {
        width: "25%"
    },
    visitMarketInput: {
        width: "15%"
    },
    visitTableStyle: {
        borderWidth: "1px",
        borderStyle: "Solid"
    },
    requiredString: {
        color: "red",
    },
    requiredStringName: {
        marginLeft: "23%",
        color: "red"
    },
    requiredStringCost: {
        marginLeft: "30%",
        color: "red"
    },
    requiredStringType: {
        marginLeft: "50%",
        color: "red"
    },
    requiredStringSpeaker: {
        marginLeft: "32%",
        color: "red"
    },
    plannerCardBackgroundColor: {
        backgroundColor: "#ffffff",
        margin: '5%',
    },
    maps: {
        width: '100%',
        height: '100%'
    },
    pressedTab: {
        backgroundColor: '#00bfff',
        color: '#ffffff'
    },
    unpressedTab: {
        backgroundColor: '#e6f9ff'
    },
    calendarHCPLabel: {
        color: "white",
        backgroundColor: "#0099cc",
        height: 50,
        paddingTop: 8
    },
    displaySearch: {
        display: "contents"
    },
    increment: {
        marginRight: 150,
        marginLeft: 70
    }
}
export default stylesMed